const API_BASE = process.env.REACT_APP_API_BASE_URL;

/**
 * Accept OSS connection request
 */
export async function acceptOssRequest({ requestId, accessToken }) {
  const res = await fetch(
    `${API_BASE}/api/oss/connection-requests/${requestId}/accept/`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    },
  );

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data?.detail || "Failed to accept request.");
  }

  return data;
}

/**
 * Reject OSS connection request
 */
export async function rejectOssRequest({
  requestId,
  accessToken,
  reason = "",
}) {
  const res = await fetch(
    `${API_BASE}/api/oss/connection-requests/${requestId}/reject/`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        rejection_reason: reason,
      }),
    },
  );

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data?.detail || "Failed to reject request.");
  }

  return data;
}
